
import React from 'react';
import { Upload } from 'lucide-react';

const FileUploadSection = () => {
  return (
    <div className="border-2 border-dashed border-gray-300 rounded-lg p-6 text-center">
      <Upload className="mx-auto h-12 w-12 text-gray-400 mb-2" />
      <p className="text-sm text-gray-600 mb-2">
        Joignez votre CV (format PDF recommandé)
      </p>
      <input
        type="file"
        accept=".pdf,.doc,.docx"
        className="hidden"
        id="cv-upload"
      />
      <label
        htmlFor="cv-upload"
        className="cursor-pointer text-fabre-green hover:text-fabre-darkgreen font-medium"
      >
        Cliquez pour sélectionner un fichier
      </label>
      <p className="text-xs text-gray-500 mt-2">
        Note : Le CV devra être joint manuellement à l'email
      </p>
    </div>
  );
};

export default FileUploadSection;
